<template>
    <div :class="['tela-dash', corEmpresaAtual]">
        <Cabecalho :idioma="idiomaAtual" />
        <div
            class="content"
            :class="{ 'no-padding': isDashboard }"
        >
            <router-view :key="$route.fullPath" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue'
    import { useEmpresaStore } from '@/stores/empresa'
    import { useUsuarioStore } from '@/stores/usuario'
    import Cabecalho from '@/components/layout/Cabecalho.vue'
    import LoaderTopo from '@/components/layout/LoaderTopo.vue'
    import { useRoute } from 'vue-router'

    export default defineComponent({
        name: 'LayoutInterno',

        components: {
            Cabecalho,
            LoaderTopo,
        },

        setup() {
            const empresaStore = useEmpresaStore()
            const usuarioStore = useUsuarioStore()
            const route = useRoute()
            const corEmpresaAtual = computed(() => {
                return empresaStore.empresaAtual?.company_color || ''
            })

            const idiomaAtual = computed(() => {
                if (usuarioStore.dadosUsuario?.idioma) {
                    return usuarioStore.dadosUsuario.idioma
                }
                if (empresaStore.empresaAtual?.language) {
                    return empresaStore.empresaAtual.language
                }
                return 'pt-BR'
            })

            const isDashboard = computed(() => {
                return (
                    route.name === 'Dashboard' ||
                    route.name === 'Company' ||
                    route.name === 'EditAdminCompany' ||
                    route.name === 'Profile'
                )
            })

            return {
                corEmpresaAtual,
                idiomaAtual,
                isDashboard,
            }
        },
    })
</script>

<style lang="scss">
    .tela-dash {
        background-color: #efefef;

        background-image: url('@/assets/images/fundo-dash.png');
        background-size: cover;
        background-position: right bottom;
        background-repeat: no-repeat;
        background-attachment: fixed;

        display: flex;
        flex-direction: column;
        min-height: 100vh;
        align-items: center;

        .content {
            margin-top: 4.2rem;
            width: 100%;
            max-width: 2500px;
            flex: 1;
            z-index: 97;
            display: flex;
            padding: 1rem 2rem 0rem 2rem;
            justify-content: center;
            overflow-x: hidden;

            @media (max-width: 1366px) {
                    padding: 1rem 1rem 0rem 1rem !important;
                }

            &.no-padding {
                padding: 1rem 0rem 0rem 0rem;

                @media (max-width: 2400px) {
                    padding: 1rem 2rem 0rem 2rem;
                }
                
            }
        }

        .background {
            height: 100vh;
            object-fit: cover;
            position: absolute;
            bottom: 0;
            right: 0;
        }

        .background-mobile {
            display: none;
        }

        :deep(input) {
            border-radius: 0.625rem !important;
        }

        #personal-date {
            margin-bottom: 0;
        }
    }
</style>
